import AnnoncementAdd from './AnnouncementAdd';

export default AnnoncementAdd;
